/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "7893725be78cb29240531d3b268485d4bce2b7cf";
